import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { PaymentMethod } from "../../../Constant";
import MyContext from "../../../contexts/MyContext";
import Logo from "../../../static/swish.svg";
import { FormWrapper } from "../FormWrapper";

export const TicketForm4 = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);

  const validate = () => {
    myContext.changeActiveSlide((myContext.activeSlide += 1));
  };

  return (
    <MyContext.Consumer>
      {(context) => (
        <React.Fragment>
          <FormWrapper continueButtonLabel={t("continue")} onContinue={validate} number={`4/5`} heading={`${t("payment_method")}`}>
            <FormControl style={{ width: "100%", margin: "1rem 0" }}>
              <RadioGroup value={context.payoutOption} onChange={(_, value) => context.changePayoutOption(value)}>
                <FormControlLabel key={PaymentMethod.SWISH} value={PaymentMethod.SWISH} control={<Radio />} label={<span dangerouslySetInnerHTML={{ __html: t("register_for_swish_payment", { logo: `<img src=${Logo} alt="Swish" style="height: 1.25rem; display: inline; vertical-align: text-top;" />` }) }} />} />
                <FormControlLabel key={PaymentMethod.SUS} value={PaymentMethod.SUS} control={<Radio />} label={t("register_for_sus_payment")} />
              </RadioGroup>
            </FormControl>
          </FormWrapper>
        </React.Fragment>
      )}
    </MyContext.Consumer>
  );
};
